/* eslint-disable */
/**
 * @file share.js
 * @desc 采用新的分享办法，地图和打车小程序联动
 * @author lishangming
 * @data 2020/04/12
 */


// 传统分享H5方式
export function homeShare(no) {

    // 防止页面href链接过长，造成微博无法分享，手动拼接分享url
    let url = location.protocol + '//' + location.host + location.pathname;
    let weChatParam = '';
    let friendParam = '';
    let weiBoParam = '';
    url = url

    weChatParam = {
        title: '打车大额红包限时派送中~',
        text: '百度地图打车全网比价，更快出发，快去领取福利吧>>',
        pic: 'https://map-mobile-resource.cdn.bcebos.com/icon/service/taxi/default/libaofenxiangtu.png'
    };
    friendParam = {
        text: '打车大额红包限时派送中，快去领取~>>',
        pic: 'https://map-mobile-resource.cdn.bcebos.com/icon/service/taxi/default/libaofenxiangtu.png'
    };
    let shareData = [{
        src: 'weixin',
        title: weChatParam.title || '百度地图',
        text: weChatParam.text,
        url: url + '?no=' + no + '&fr=wx',
        contentType: 'text',
        pic: weChatParam.pic
    },
    {
        src: 'friend',
        text: friendParam.text,
        url: url + '?no=' + no + '&fr=wx',
        contentType: 'text',
        pic: friendParam.pic
    }];
    if (window.yymap && window.yymap.naa) {
        window.yymap.naa.initShare(shareData);
    }
};

// 打开分享面板的方法
export function openShare(helpId) {
    // 防止页面href链接过长，造成微博无法分享，手动拼接分享url
    let url = location.protocol + '//' + location.host + location.pathname;
    let weChatParam = '';
    let friendParam = '';
    let weiBoParam = '';
    url = url;

    weChatParam = {
        text: '五一打车，助力领打车金',
        pic: 'https://cjh-amis.cdn.bcebos.com/2021-4/1618336989383/share-big.png'
    };
    friendParam = {
        text: '五一打车，优惠畅行，立即领取>>',
        pic: 'https://cjh-amis.cdn.bcebos.com/2021-4/1618336989383/share-big.png'
    };
    weiBoParam = {
        text: '五一打车，优惠畅行，立即领取>>',
        pic: 'https://cjh-amis.cdn.bcebos.com/2021-4/1618336989383/share-big.png'
    };
    const wxPath = 'https://scenes.map.baidu.com/static/subpages/dache-lantern/dache-lantern.html?helpid=' + helpId;
    let shareData = [{
        shareTo: 'weixin',
        title: weChatParam.text,
        content: weChatParam.text,
        // url: url + '?fr=wx',
        contentType: 'text',
        pic: weChatParam.pic,
        wx_mnp_type: 0,
        wx_mnp_path: '/pages/commonweb/commonweb?url=' + encodeURIComponent(wxPath),
        wx_mnp_username: 'gh_cdb4394feea7',
        url: 'http://cjh-fe-zhuqijia-2020.bcc-bdbl.baidu.com:8085/static/dache-labourday/dache-labourday.html?share=1',
        imageSource: weChatParam.pic,
    },
    {
        shareTo: 'weixin_friend',
        title: friendParam.text,
        url: url + '?fr=wx',
        contentType: 'text',
        imageSource: friendParam.pic
    },
    {
        shareTo: 'sina_weibo',
        title: weiBoParam.text,
        url: url + '?fr=weibo',
        pic: weiBoParam.pic
    }];


    if (window.yymap.nativeAppAdapter.plat.isNative) {
        // 端内
        let bdapiHead = 'bdapi://openSharePrompt?';
        let param = {
            shareList: shareData
        };
        const bdapi = bdapiHead + encodeURIComponent(JSON.stringify(param));
        window.yymap.nativeAppAdapter.requestBdApi(bdapi);
    } else {
        // 端外
        window.yymap.nativeAppAdapter.openShare();
    }
}



/* eslint-enable */
